import React, { useEffect, useState } from 'react';
import { getExistingSubscription, isPushSupported, subscribeToPush, unsubscribeFromPush } from '../lib/pushNotifications';
import styles from '../styles/PushOptIn.module.css';

// Boton reutilizable para activar/desactivar el canal push (instantaneo,
// aditivo al email que ya se manda desde server/services/alertNotifications.js).
// Se usa en AlertBuilder, MyAlerts y el "Guardar" de ProductList -- solo
// tiene sentido con cuenta, el backend exige requireUser en /api/push/subscribe.
const PushOptIn = ({ user }) => {
    const [subscribed, setSubscribed] = useState(null);
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        if (!user || !isPushSupported()) {
            setSubscribed(false);
            return;
        }
        getExistingSubscription()
            .then((subscription) => setSubscribed(Boolean(subscription)))
            .catch(() => setSubscribed(false));
    }, [user]);

    if (!user || !isPushSupported() || subscribed === null) {
        return null;
    }

    const handleClick = async () => {
        setBusy(true);
        setError('');
        try {
            if (subscribed) {
                await unsubscribeFromPush();
                setSubscribed(false);
            } else {
                await subscribeToPush();
                setSubscribed(true);
            }
        } catch (err) {
            setError(err.message || 'No se pudo activar las notificaciones.');
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className={styles.pushOptIn}>
            <button type="button" className={styles.pushButton} onClick={handleClick} disabled={busy}>
                {subscribed
                    ? '🔔 Avisos instantáneos activados en este dispositivo'
                    : '🔔 Activar avisos instantáneos en este dispositivo'}
            </button>
            {error && <p className={styles.pushError}>{error}</p>}
        </div>
    );
};

export default PushOptIn;
